import React, { useState, useEffect } from "react";
import { Snackbar } from "@material-ui/core";
import MuiAlert, { AlertProps } from "@material-ui/lab/Alert";

interface Props {
  text?: string;
  severity: "error" | "warning" | "info" | "success";
  onClosed: () => void;
}

function Alert(props: AlertProps) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

export const NotificationSnackbar = ({ text, severity, onClosed }: Props): JSX.Element | null => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    setOpen(!!text && text.trim() !== "");
  }, [text]);

  if (!text) return null;

  const handleClose = (event: React.SyntheticEvent | React.MouseEvent, reason?: string) => {
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
    // call the callback function
    onClosed();
  };

  return (
    <Snackbar open={open} onClose={handleClose} autoHideDuration={5000}>
      <Alert severity={severity}>{text}</Alert>
    </Snackbar>
  );
};
